import feathersClient, { makeServicePlugin, BaseModel } from '../../feathers-client'

class Documents extends BaseModel {
  // Required for $FeathersVuex plugin to work after production transpile.

  static modelName = 'Documents'
  // Define default properties here
  static instanceDefaults () {
    return {
      type: null,
    }
  }
}
const servicePath = 'documents'
const servicePlugin = makeServicePlugin({
  Model: Documents,
  service: feathersClient.service(servicePath),
  servicePath,
})

// Setup the client-side Feathers hooks.
feathersClient.service(servicePath).hooks({
  before: {
    all: [],
    find: [],
    get: [],
    create: [],
    update: [],
    patch: [],
    remove: [],
  },
  after: {
    all: [],
    find: [],
    get: [],
    create: [],
    update: [],
    patch: [],
    remove: [],
  },
  error: {
    all: [],
    find: [],
    get: [],
    create: [],
    update: [],
    patch: [],
    remove: [],
  },
})

export default servicePlugin
